export const PLANS_QUERY_KEYS = {
  ALL: ["plans"],
  CURRENT_PLAN: ["current-plan"],
  SUBSCRIPTION_TYPES: ["subscription-types"],
  SUBSCRIPTION_PLANS_BY_TYPE: ["subscription-plans-by-type"],
  USER_SETTINGS: ["user-settings"],
  USER_SUBSCRIPTION: ["user-subscription"],
  WEB_SUBSCRIPTION_PLANS: ["web-subscription-plans"],
  TRANSACTIONS: ["transactions"],
  INVOICES: ["invoices"],
  TRANSACTION_DETAILS: ["transaction-details"],
  INVOICE_DETAILS: ["invoice-details"],
} as const;
